import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const programas = {
	state: {
        programasDeLaEmpresa : '',
		programasActivos : ''
	},
	getters: {
        getProgramasDeLaEmpresa: state => state.programasDeLaEmpresa,
		getProgramasActivos: state => state.programasActivos,
	},
	actions: {
        requestProgramasPracticasEmpresa({ commit }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/programasDeLaEmpresa').then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setProgramasDeLaEmpresa',response.data.datos)
					} else {
						resolve(false);
						commit('setCompleteError', response);
					}
				}).catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestProgramasPracticas({ commit }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Publico/programasPracticasActivos').then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setProgramasActivos',response.data.datos)
					} else {
						reject(false);
						commit('setCompleteError', response);
					}
				}).catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
        requestPrograma({ commit,getters },id) {


			let url = (getters.getUserType == "Alumno") ? 'api/Alumno/detallePrograma/' : '/api/Empresa/detallePrograma/'

			return new Promise((resolve, reject) => {
				axios.get(url+id).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						reject(false);
						commit('setCompleteError', response);
					}
				}).catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
        },
        requestAdhesionPrograma({ commit,getters },id) {

			let url = (getters.getUserType == "Alumno") ? '/api/Alumno/solicitaAdhesionPrograma/' : '/api/Empresa/solicitaAhesionPrograma/'

			return new Promise((resolve, reject) => {
				axios.post(url+id).then(response => {
					if (response.data.status == 0) {
						if((getters.getUserType == "Alumno")){

							if(getters.getClient == "usal"){
								commit('setError', 540);
							}else{
								commit('setError', 534);
							}

						}else{
							commit('setError', 533);
						}
						resolve(true);
					} else {
						reject(false);
						commit('setCompleteError', response);
					}
				}).catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
	},
	mutations: {
        setProgramasDeLaEmpresa: function (state, data) {
			data = Object.entries(data).sort(function (p1,p2) {
				return (p1[1] < p2[1]) ? -1 : 1;
			});
			state.programasDeLaEmpresa = data;
		},
		setProgramasActivos: function (state, data) {
			state.programasActivos = data;
		}
	}
}

export default programas;



// WEBPACK FOOTER //
// ./src/store/programas-practicas.js